module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Kandidaten":"The candidate","har visat intresse för att vara med i poolen":"has shown interest in joining the candidate pool"},"sv":{"Kandidaten":"Kandidaten","har visat intresse för att vara med i poolen":"har visat intresse för att vara med i kandidatpoolen"}}')
  delete Component.options._Ctor
}
